import { render } from "./CalendarHomeNotificationChangeMobile.vue?vue&type=template&id=5dd15982&scoped=true&ts=true"
import script from "./CalendarHomeNotificationChangeMobile.vue?vue&type=script&lang=ts"
export * from "./CalendarHomeNotificationChangeMobile.vue?vue&type=script&lang=ts"

import "./CalendarHomeNotificationChangeMobile.vue?vue&type=style&index=0&id=5dd15982&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd15982"]])

export default __exports__